import i18n from 'src/i18n';
import { HistoryActionTypeEnum, UserDTO } from '../api';
import { SelectOptions } from '../types/';
import { toClean } from 'number-string';
import { Markets } from '../types';
import { isMarket } from '../utils/markets';
import _ from 'lodash';
import * as XLSX from 'xlsx';
import { ExportToCsv } from 'export-to-csv';
import { Storage } from 'aws-amplify';
import i18next from 'i18next';
import toaster from '../utils/toaster';
import { ClienteEnum, RecordTypeEnum, RoleEnum } from '../api/models/Enums';

export const arrayPrepend = (arr, val) => {
	var newArr = arr.slice();
	newArr.unshift(val);
	return newArr;
};

export const emailIsValid = (email) => {
	return /\S+@\S+\.\S+/.test(email);
};

export const renderFloatAsStr = (str: string) => {
	str = str.replaceAll('.', ',');
	str = str.replace(/[^\d,]/g, '');
	return str.split(',', 2).join(',');
};

export const strToFloat = (str: string) => {
	str = str.replace(',', '.');
	return Number.isNaN(parseFloat(str)) ? 0 : parseFloat(str);
};

export function removeDuplicates<T>(arr: Iterable<T>): T[] {
	const s: Set<T> = new Set(arr);
	return [...s];
}

// prepare options from ARRAY for the select tags to be fed to the Select component from react-select
export const arrayToOptions = (array: string[]): SelectOptions[] => {
	return array.map((item: string) => {
		return {
			value: item,
			label: item || '',
		};
	});
};
// prepare options from STRING for the select tags to be fed to the Select component from react-select
export const stringToOption = (str: string, value: string = '') => {
	return {
		value: str,
		label: str || '',
		originalValue: value,
	};
};

export const isObj = <T>(arg: T): boolean => {
	if (typeof arg === 'object' && !Array.isArray(arg) && arg !== null) {
		return true;
	}
	return false;
};

export const isNotEmptyObject = <T>(arg: T): boolean => {
	if (isObj(arg) && !!Object.keys(arg as keyof T).length) {
		return true;
	}
	return false;
};

export const formatDate = (
	dateString: string,
	locale: string,
	hasTime: boolean,
	timeZone: string = 'Europe/Rome'
) => {
	const date = new Date(dateString);

	const options: Intl.DateTimeFormatOptions = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		...(hasTime && {
			hour: '2-digit',
			minute: '2-digit',
			timeZone,
		}),
	};

	return date.toLocaleString(locale, options);
};

export const formatDateTime = (dateString: string, locale: string) => {
	// locale = 'en-US', 'de-DE', 'it-IT', etc.
	const date = new Date(dateString);
	const options: Intl.DateTimeFormatOptions = {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
		hour12: locale === 'it-IT',
	};

	return date.toLocaleString(locale, options);
};

export const translateServices = (service: string) => {
	let t = '';

	switch (service) {
		case 'treno_di_gomme':
			t = i18n.t('set_of_tyres');
			break;
		case 'auto_sostitutiva':
			t = i18n.t('replacement_car');
			break;
		case 'kasko':
			t = i18n.t('kasko');
			break;
		case 'rca':
			t = i18n.t('rca');
			break;
		case 'i_f':
			t = i18n.t('i_f');
			break;
		case 'manutenzione_ordinaria':
			t = i18n.t('ordinary_maintenance');
			break;
		case 'manutenzione_straordinaria':
			t = i18n.t('straordinary_maintenance');
			break;
		case 'tipo_gomma':
			t = i18n.t('tipo_gomma');
			break;
		case 'gomme_illimitate_YN':
			t = i18n.t('gomme_illimitate_YN');
			break;
		case 'num_treno_gomme_estive':
			t = i18n.t('n_treno_gomme_estive');
			break;
		case 'num_treno_gomme_invernali':
			t = i18n.t('n_treno_gomme_invernali');
			break;
		case 'auto_sostitutiva_gruppo':
			t = i18n.t('auto_sostitutiva_gruppo');
			break;
		case 'additional_note':
			t = i18n.t('notes');
			break;
	}

	return t;
};

export const noopFn = () => {};

export const calcRemaingOptionTime = (user, storico) => {
	const actionTypesOptionableVehicle = [
		HistoryActionTypeEnum.OPZIONAMENTO_CANCELLATO,
		HistoryActionTypeEnum.OPZIONAMENTO_SCADUTO,
	];

	let canBeOptioned: boolean = false;
	let timestamp;

	for (let i = storico.length - 1; i >= 0; i--) {
		const currentStorico = storico[i];
		// check if username is the same as the one who did the action
		if (user.username === currentStorico.utente) {
			// check if the action is either OPZIONAMENTO_CANCELLATO or OPZIONAMENTO_SCADUTO
			if (actionTypesOptionableVehicle.includes(currentStorico.type)) {
				const threeDaysInMillis = 3 * 24 * 60 * 60 * 1000;
				const timestampInMillis = new Date(currentStorico.timestamp).getTime();
				const targetTimestamp =
					new Date(currentStorico.timestamp).getTime() + threeDaysInMillis;

				const isOlderThanThreeDays =
					Date.now() - timestampInMillis > threeDaysInMillis;
				if (isOlderThanThreeDays) {
					canBeOptioned = true;
				} else {
					timestamp = targetTimestamp;
					canBeOptioned = false;
				}
				break;
			} else {
				canBeOptioned = true;
			}
		} else {
			canBeOptioned = true;
		}
	}
	return { canBeOptioned, timestamp };
};

export const appendUniqueDataToFilename = (filename, values) => {
	// we append the nr_ordine and the timestamp because we cannot upload files with the same name on S3
	const filenameSplit = filename.split('.');
	const extension = filenameSplit.pop();
	const rowFilename = filenameSplit.shift();
	const timestamp = new Date().toISOString().replace(/\.\d{3}Z$/, '');
	return `${rowFilename}---${values.nr_ordine}---${timestamp}.${extension}`;
};

export const getCleanFilename = (rowFilename) => {
	const arrayFromSplit = rowFilename.split('---');
	if (arrayFromSplit.length > 0) {
		return arrayFromSplit[0];
	}
};

export const getCookieValue = (cookieName) => {
	const cookies = document.cookie.split('; ');
	for (const cookie of cookies) {
		const [name, value] = cookie.split('=');

		if (name === cookieName) {
			return decodeURIComponent(value);
		}
	}
	return null;
};

export const randomString = (length: number) => {
	const chars =
		'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
	let result = '';
	for (let i = 0; i < length; i++) {
		result += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	return result;
};

export const getUrl = (to: string, q: { [key: string]: string } = {}) => {
	const params = new URLSearchParams();

	for (let k in q) {
		params.set(k, q[k]);
	}

	let url = to;

	if (Object.keys(q).length > 0) {
		url += '?' + params.toString();
	}

	return url;
};

export const handleSym = (value, cs) => {
	let val = '';
	switch (cs) {
		case 'value':
			if (value?.includes('€')) {
				val = value?.slice(1, value.lenght);
			} else {
				val = value?.slice(0, -1);
			}
			break;
		case 'symbol':
			if (value?.includes('€')) {
				val = value?.slice(0, 1);
			} else {
				val = value?.slice(-1);
			}
			break;
		default:
			break;
	}

	return val?.trim();
};

export const downloadBase64File = (base64String: string, filename: string) => {
	// Split the data URI to get content type and base64 data
	// const parts = base64String.split(';base64,');
	// const contentType = parts[0].split(':')[1];

	const mimeString = 'application/octet-stream';

	// Create an anchor element (a tag)
	const link = document.createElement('a');

	link.href = 'data:' + mimeString + ';base64,' + base64String;
	link.download = filename;
	link.click();

	// Revoke the object URL to avoid memory leaks (important)
	setTimeout(() => link.remove(), 1000);
};

export function resizeImage(
	image: HTMLImageElement,
	maxWidth: number,
	maxHeight: number
) {
	var canvas = document.createElement('canvas');
	var width = image.width;
	var height = image.height;

	// Calculate the new dimensions, maintaining the aspect ratio
	if (width > height) {
		if (width > maxWidth) {
			height *= maxWidth / width;
			width = maxWidth;
		}
	} else {
		if (height > maxHeight) {
			width *= maxHeight / height;
			height = maxHeight;
		}
	}

	// Set the canvas dimensions to the new dimensions
	canvas.width = width;
	canvas.height = height;

	// Draw the resized image on the canvas
	var ctx = canvas.getContext('2d')!;
	ctx.drawImage(image, 0, 0, width, height);

	return canvas;
}

export const numberFormat = (num: any) => {
	// if (num === undefined) {
	//   return '';
	// }

	if (typeof num !== 'number' && typeof num !== 'string') {
		return '';
	}

	if (num === '') {
		return 0;
	}

	return toClean(num, {
		decimalMark: ',',
		thousandSeparator: '.',
	});
};

export const capitalize = (s: string) => {
	if (s.length) {
		return String(s[0]).toUpperCase() + String(s).slice(1);
	}

	return '';
};

export const changeHorizonSpainToHorizon = (value) => {
	if (isMarket(Markets.es)) {
		if (value === 'Horizon_Spagna' || value === 'Horizon Spagna') {
			return 'Horizon';
		}
	}

	return value;
};

export const deserializeMessage = (jsonString: string | undefined): string => {
	if (!jsonString) return '';
	try {
		const parsed = JSON.parse(jsonString);
		return parsed.message || jsonString;
	} catch (error) {
		console.error('Failed to parse log message JSON:', error);
		return jsonString;
	}
};

export const removeFileExtension = (filename: string): string => {
	return filename.split('.').slice(0, -1).join('.');
};
export const toBoolean = (value: string): boolean =>
	_.toLower(_.trim(value)) === 'true';

export const parseBool = (value: string, defaultValue = false) =>
	/^(y|yes|true|si|1)$/i.test(value)
		? true
		: /^(n|no|false|0)$/i.test(value)
		? false
		: defaultValue;

export const sleep = async (ms: number, fail: boolean = false) =>
	new Promise((res, rej) => setTimeout(() => (fail ? rej(ms) : res(ms)), ms));

export const extractModelName = (marca: string, modello: string): string => {
	const modelMatch = modello?.match(/\b(2008|3008|5008)\b/);

	if (marca?.toLowerCase() === 'peugeot' && modelMatch) {
		return modelMatch[0];
	}
	return modello?.replace(/\b(19|20)\d{2}\b/, '').trim();
};

export const extractModelYear = (modello: string): string | null => {
	const allMatches = modello?.match(/\b(19|20)\d{2}\b/g);
	return allMatches && allMatches.length > 0
		? allMatches[allMatches.length - 1]
		: null;
};

export const downloadXLSX = (downloadData, filename) => {
	// XLSX takes the index of the object passed as downloadData as the header, so we need to skip it

	const worksheet = XLSX.utils.json_to_sheet(downloadData, {
		skipHeader: true,
	});
	const workbook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(workbook, worksheet, filename);
	XLSX.writeFile(workbook, `${filename}.xlsx`);
};

export const downloadCSV = (downloadData, filename) => {
	const options = {
		filename,
	};
	const csvExporter = new ExportToCsv(options);
	csvExporter.generateCsv(downloadData);
};

export const parseJsonList = (value?: string) => {
	if (!value) return [];
	try {
		const parsedValue = JSON.parse(value);
		if (Array.isArray(parsedValue)) return parsedValue;
		return [parsedValue];
	} catch (error) {
		console.warn('Failed to parse json list value', error);
		return [];
	}
};

export const isEdge = () => {
	const agent = navigator.userAgent;
	return /Edg\//.test(agent) || /Edge\//.test(agent);
}

export const uploadFilesToBucket = async (sendFiles, uploadFiles) => {
  let filesToUploadList: { filename: string, key: string, file: File, type: string }[] = []

  const uploadContent = {
    'sendFiles': { data: sendFiles },
    'uploadFiles': { data: uploadFiles }
  }

  for (const type in uploadContent) {
    const fileArray: { data: File[], type: 'sendFiles' | 'uploadFiles' } = uploadContent[type]

    if (fileArray.data.length) {
      let uploadOps: any[] = []

      fileArray.data.forEach(file => {
        const ext = file.name.split('.').pop()
        const key = `opportunity_uploads/${randomString(10)}.${ext}`
        filesToUploadList.push({ type, file, filename: file.name, key })
      })

      uploadOps = filesToUploadList.map(obj => {
        return Storage.put(obj.key, obj.file, {
          contentType: obj.file.type,
          bucket: process.env.REACT_APP_AWS_STORAGE_BUCKET_SALESFORCE_IMPORT,
        });
      })

      try {
        await Promise.all(uploadOps)
      } catch (e) {
        console.error(e);
        toaster.error(i18next.t('error_loading_file'))
        throw e;
      }
    }
  }

  return filesToUploadList.map(el => {
    return { ...el, key: `public/${el.key}` }
  })
}

export const getDerivedRecordTypeId = (Cliente__c:  ClienteEnum): string => {
  switch (Cliente__c) {
    case 'Azienda con partita IVA':
      return RecordTypeEnum.Azienda;
    case 'Libero professionista':
      return RecordTypeEnum.Libero_Professionista;
    case 'Privato':
      return RecordTypeEnum.Privato;
    default:
      return '';
  }
};

export const isPreprod = () => {
	if (window?.location?.hostname?.includes('preprod-mobilityplatform')) {
		return true;
	}

	return process.env.REACT_APP_ENV === 'production'
		&& !window?.location?.hostname?.includes('mobilityplatform.horizonautomotive');
}

export const showEnvBadge = () => {
	if (!process.env.REACT_APP_ENV) return false;

	if(isPreprod()) {
			return true;
	}

	return ['development', 'staging', 'preprod'].includes(process.env.REACT_APP_ENV);
}

export const getAppEnv = () => {
	if (isPreprod()) {
		return { label: 'PRE-PROD', bg: 'danger' };
	}

	switch(process.env.REACT_APP_ENV) {
		case 'development':
			return { label: 'DEVELOPMENT', bg: 'success', text: 'dark' };
		case 'staging':
			return { label: 'STAGING', bg: 'warning', text: 'dark' };
		case 'preprod':
			return { label: 'PRE-PROD', bg: 'danger' };
	}
}

export const APP_ENV = {
	showEnv: showEnvBadge(),
	env: getAppEnv() as any
}

export const isInvalidNumber = (value: any, nullable: boolean = true): boolean => {
	if (_.isNil(value) && nullable) {
		return false;
	}

	try {
		const numericValue = Number(value);
		return isNaN(numericValue);
	} catch (err) {
		console.warn(err);
		return true;
	}
};

export const machineCode = (string: string) =>
  string
    .trim()
    .toLocaleLowerCase()
    .replace(/[àáäâ]/g, 'a')
    .replace(/[èéëê]/g, 'e')
    .replace(/[ìíïî]/g, 'i')
    .replace(/[òóöô]/g, 'o')
    .replace(/[ùúüû]/g, 'u')
    .replace(/[^A-Za-z0-9 ]/g, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/\s/g, '-')
    .replace(/\r/g, '-');

export const canViewReportersPage = (userRole: RoleEnum, userReferencePartnerList?: string[]) => {
	if (!isMarket(Markets.it)) return false;
	if (userRole !== RoleEnum.SALES_DEALER) return false;
	return true;
	// if(process.env.REACT_APP_ENV && ['development', 'staging'].includes(process.env.REACT_APP_ENV)) {
	// 	return true;
	// }

	// if (!userReferencePartnerList?.length) return false;

	// const allowed = [
	// 	'ROMANA DIESEL SPA',
	// 	'PETRAROLO & CO',
	// 	'BIFORCE SRL',
	// 	'F1 SPA - FARINA',
	// 	'CARRARO SPA',
	// 	'MJ CAR SRL',
	// 	'AUTOEQUIPE SPA'
	// ].map(machineCode);
	// const currentUserDealer = machineCode(userReferencePartnerList[0]?.toUpperCase())
	// console.debug({allowed, currentUserDealer});

	// return allowed.includes(currentUserDealer);
}

export const hasUserAnyTag = (dto: UserDTO | null, tags: string[]) => {
	if (!dto) return false;
	if (!dto.visibility_tag?.length) return false;
	return dto.visibility_tag.some(tag => tags.includes(tag));
}

const FMT = new Intl.NumberFormat('it-IT', {
	style: 'currency',
	currency: 'EUR',
});

export function formatCurrency(n: number): string {
	return FMT.format(n);
}

export const toHttps = (url?: string) => url?.replace(/^http:\/\//i, 'https://');

export const secureImageList = (list: Array<{ url?: string }>) => list.map((img) => ({ ...img, url: toHttps(img?.url) }));
